import { getOrgRanges, getOrgReportRawApi, getOrgReportSummaryApi } from "@/apis/org-api"
import { create } from "zustand"
import { halfDoughnutStore } from "./_components/half-doughnut/half-doughnut-store"
import { leakSeverityStore } from "./_components/leak-severity/leak-severity-store"
import { tableStore } from "./_components/table/table-store"
import { tableSize } from "@/routes/org/org-const"

const tableBundle = {
  columns: {
    customer_id: { ko: "수용가 번호", en: "Customer ID", es: "ID de cliente", isTh: true },
    customer_name: { ko: "고객명", en: "Customer Name", es: "Nombre del cliente", isTh: true },
    business_type: { ko: "업종명", en: "Business Type", es: "Tipo de negocio", isTh: true },
    caliber: {
      ko: "구경",
      en: "Diameter ",
      es: "Diámetro ",
      unit: { ko: "mm", en: "mm", es: "mm" },
      isTh: true
    },
    office: { ko: "사업소", en: "Office", es: "Oficina", isTh: true },
    block_mid: { ko: "중블럭", en: "Block mid", es: "Bloque medio", isTh: false },
    block_small: { ko: "소블럭", en: "Block small", es: "Bloque pequeño", isTh: false },
    leak_count: { ko: "누수 횟수", en: "Leak Count", es: "Número de fugas", isTh: false },
    address: { ko: "주소", en: "Address", es: "Dirección", isTh: true },
    leak_hours: {
      ko: "누수지속시간",
      en: "Leak Duration ",
      es: "Duración de fuga ",
      unit: { ko: "시간", en: "hrs", es: "horas" },
      isTh: true
    },
    leak_volume: {
      ko: "누수량",
      en: "Leak Volume ",
      es: "Volumen de fuga ",
      unit: { ko: "m³", en: "m³", es: "m³" },
      isTh: true
    },
    usage_volume: {
      ko: "사용량",
      en: "Usage ",
      es: "Consumo ",
      unit: { ko: "m³", en: "m³", es: "m³" },
      isTh: true
    },
    leak_rate: {
      ko: "누수율",
      en: "Leak Rate ",
      es: "Tasa de fuga ",
      unit: { ko: "%", en: "%", es: "%" },
      isTh: true
    },
    leak_type: { ko: "누수유형", en: "Leak Type", es: "Tipo de fuga", isTh: true },
    leak_severity: { ko: "누수 심각도", en: "Leak Severity", es: "Severidad de fuga", isTh: true },
    leak_index: { ko: "누수 지수", en: "Leak Index", es: "Índice de fuga", isTh: false },
    leak_start_at: { ko: "누수 시작 시점", en: "Leak Severity", es: "Inicio de fuga", isTh: false },
    leak_end_at: { ko: "누수 종료 시점", en: "Leak Severity", es: "Fin de fuga", isTh: false },
    dong_name: { ko: "행정동", en: "Leak Severity", es: "Barrio", isTh: false },
    gu_name: { ko: "자치구", en: "Leak Severity", es: "Distrito", isTh: false }
  }
}

export const orgStore = create((set) => ({
  overview: {},
  severityInfo: {},

  getOrgReportSummary: async (org) => {
    const { overview, severity_info } = await getOrgReportSummaryApi(org)

    const { setCharts: setDoughnutCharts } = halfDoughnutStore.getState()
    const { setChart: setLeakSeverityChart } = leakSeverityStore.getState()

    set({ overview, severityInfo: severity_info })

    setDoughnutCharts(overview)
    setLeakSeverityChart(severity_info)

    return true
  },

  getOrgReportRaw: async (org) => {
    const { headers, rows, total, page, size } = await getOrgReportRawApi(org, {
      include_headers: true
    })

    const ranges = await getOrgRanges(org)

    const { setSort, setHeaders, setInitialRanges, setInitialEnums } = tableStore.getState()

    const headerMapping = headers
      .filter((h) => tableBundle.columns[h.key].isTh)
      .map((h) => ({
        ...h,
        onClick: () => (h.sortable ? setSort(org, h.key) : null),
        label: { ...tableBundle.columns[h.key] },
        width: tableSize[h.key]
      }))

    setHeaders(headerMapping)

    // ! rows + pageMeta 직접 세팅
    tableStore.setState({
      rows,
      pageMeta: {
        totalCount: total,
        page,
        size,
        totalPage: Math.ceil(total / size)
      }
    })

    // range 초기값 세팅
    for (const key in ranges) {
      setInitialRanges(key, ranges[key])
    }

    const enumFilters = headers.filter((h) => h.enum)
    enumFilters.forEach((f) => setInitialEnums(f.key, f.enum))
  }
}))
